import { GetsCustom } from "../../api-calls/GetsDirect";

export async function fetchDownloadUrl() {
    const response = await GetsCustom("PresignedUrl/presigned-exec-url", {
        method: "get",
        headers: {
            apikey: process.env.REACT_APP_DOWNLOADKEY,
        },
    });
    return response.presignedUrl;
}
